namespace $ { $mol_style_attach( "mol/chat/chat.view.css",
 "[mol_chat_page] {\n\tflex: 1 0 30rem;\n}\n"
) }